import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormCanDeactivate } from 'src/app/core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { BASE_HREF, NUM_FILE_TABLE, FILE_TABLE_DEF, LINKS_EXTERNAL, ROOT_INTERNA, STORAGE, FILE_TABLE, NUM_FILE_TABLE_OPTIONS } from '../../../../../core/utils/constants';
import { WebServicesService } from '../../../internal-home/pages/webservices/webservices.service';
import { TranslateService } from '@ngx-translate/core';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { Wsdefs } from 'src/app/core/entities/wsdefs.model';
import * as _ from 'lodash';
import { WebservicesParse } from 'src/app/core/entities/webservicesparse.model';
import { WebserviceValorDato } from 'src/app/core/entities/webservicevalordato.model';
import { DialogsDatoswsComponent } from 'src/app/shared/components/dialogs/dialogs-datosws/dialogs-datosws.component';
import { registerLocaleData, Location } from '@angular/common';
import es from '@angular/common/locales/es';

@Component({
  selector: 'app-webservices',
  templateUrl: './webservices.component.html',
  styleUrls: ['./webservices.component.scss']
})
export class WebservicesComponent extends FormCanDeactivate implements OnInit {

  /** Rutas a imagenes de ws parte interna */
  readonly DOWNLOAD: String = BASE_HREF + '/assets/images/download-w.svg';
  readonly DOWNLOAD_ARROW: String = BASE_HREF + '/assets/images/download-arrow.svg';
  readonly UP_CHEVRON: String = BASE_HREF + '/assets/images/up-chevron.svg';
  readonly DOWN_ARROW: String = BASE_HREF + '/assets/images/down-arrow.svg';

  /**rutas externas a webs y servicios de Reus */
  readonly REUS_AVISOS: String = LINKS_EXTERNAL.REUS_AVISOS;

  @ViewChild('f', {static: true})
  form!: NgForm;
  data: any;
  loading: boolean = true;
  loadingWSEnabled: boolean = true;
  posicionY: number = 0;
  error: boolean = false;

  numFilas: any[] = NUM_FILE_TABLE;
  numeroFilas : number = FILE_TABLE_DEF;

  ClickedRow:any;  

  responsiveOptions = [
    {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 3
    },
    {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 2
    },
    {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1
    }
  ];

  constructor(public webservicesService: WebServicesService,
              private translateService: TranslateService,
              private dialog: MatDialog,
              private router: Router,
              private location: Location) {
                super();
                //this.data = this.router.getCurrentNavigation().extras.state;
                this.data = this.location.getState();
                this.ClickedRow = function(index : any){  
                    let datosWs = new Array<WebserviceValorDato>();
                    datosWs = _.cloneDeep(index);
                    this.dialogoValorWS(datosWs);
                }  
              }

  ngOnInit() {
    registerLocaleData(es);
    this.numFilasCombo();
    this.error = false;
    this.loadingWSEnabled = false;
    this.webservicesService.loadingWS = false;
    this.loading = false;
    if (this.data != undefined) {
      this.loading = true;
      this.webservicesService.initView(this.data).subscribe(res => {
        console.log(res);
        this.error = false;
        this.loading = false;
      }, error => {
        this.error = true;
        this.loading = false;
        this.errorCargaWS('WARNINGS.error_ws');
        console.log("Error: " + error);
      });
    }
  }

  /**
  * @description
  * Cambia a valor numérico el check para elegir nº columnas tablas
  * @param error numero columnas
  */
  public retornarNumFilas(dato: string):number{
    this.numeroFilas = +dato;
    return this.numeroFilas;
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorCargaWS(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  /**
  * @description
  * Gestión de la barra de menu al cerrarse para dispositivos móviles
  */
  gestionMenuMovilCerrar(){
    var menuCerrar = document.getElementById("menumovilCerrar");
    let menuAbrir = document.getElementById("collapseOne");
    if (menuAbrir && menuCerrar) {
      if(window.screen.width < 500){
        menuAbrir.style.display = "none";
        menuCerrar.style.display = "block";
      }else{
        menuAbrir.style.display = "";
        menuCerrar.style.display = "";
      }
    }
  }

  /**
  * @description
  * Gestión de la barra de menu al abrirse para dispositivos móviles
  */
  gestionMenuMovilAbrir(){
    var menuCerrar = document.getElementById("menumovilCerrar");
    let menuAbrir = document.getElementById("collapseOne");
    if (menuAbrir && menuCerrar) {
      if(window.screen.width < 500){
        menuAbrir.style.display = "block";
        menuCerrar.style.display = "none";
      }else{
        menuAbrir.style.display = "";
        menuCerrar.style.display = "";
      }
    }
  }

  /**
  * @description
  * Lanza la llamada al WS seleccionado por el cliente
  * @param dato Webservice a mostrar
  * @param posicionA Posicion que ocupa el setvalue seleccionado
  * @param posicionB Posicion que ocupa el ws seleccionado
  */
  public recogerWS(dato: Wsdefs, posicionA: number, posicionB: number, actPosic: number, evento: any){
    this.numeroFilas = FILE_TABLE_DEF;
    this.numFilasDefecto();

    /**En dispositivos móviles siempre después de pulsar una opción el menu se plegará**/
    let menuAbrir = document.getElementById("collapseOne");
    let menuCerrar = document.getElementById("menumovilCerrar");

    if (menuAbrir && menuCerrar) {
      if(window.screen.width < 500){
        menuAbrir.style.display = "none";
        menuCerrar.style.display = "block";
        this.posicionY = 0;
        window.scrollTo(0, 0);
      }else{
        menuAbrir.style.display = "";
        menuCerrar.style.display = "";

        if(actPosic === 0){
          this.posicionY = evento.pageY - 345;
          window.scrollTo(0, this.posicionY);
        }else{
          window.scrollTo(0, 0);
          this.posicionY = 0;
        }
      }
    }

    /**Si el WS esta activado dependerá si refrescamos o no para pasar por el subscribe*/
    if (dato.enable === 1) {
        this.loadingWSEnabled = true;
        this.webservicesService.recogerWSEnable(dato, posicionA, posicionB).subscribe(res => {
            console.log(res);
            this.error = false;
            this.loadingWSEnabled = false;
        }, error => {
            this.error = true;
            this.loadingWSEnabled = false;
            this.errorCargaWS('WARNINGS.error_ws');
            console.log("Error: " + error);
        });

    /**Si el WS esta desactivado tendremos que ir a buscar los datos */
    } else {
        this.loadingWSEnabled = true;
        this.webservicesService.recogerWS(dato, posicionA, posicionB).subscribe(res => {
            console.log(res);
            this.error = false;
            this.loadingWSEnabled = false;
        }, error => {
            this.error = true;
            this.loadingWSEnabled = false;
            this.errorCargaWS('WARNINGS.error_ws');
            console.log("Error: " + error);
      });
    }

  }

  /**
  * @description
  * Lanza la llamada al WS seleccionado por el cliente al refrescar datos
  * @param dato Webservice a mostrar
  */
  public recogerWSRefres(dato: Wsdefs){
    console.log(this.webservicesService.webservicesParse);
    if(dato.enable == 0){
      for(let i = 0; i < this.webservicesService.webservicesParse.length; i++){
        if(this.webservicesService.webservicesParse[i].code == dato.code){
          this.webservicesService.webservicesParse.splice(i, 1);
        }
      }
    }else{
      this.webservicesService.wsenabledrefresh = true;
    }
    console.log(this.webservicesService.webservicesParse);
  }


  /**
  * @description
  * Lanza la llamada al WS seleccionado por el cliente al refrescar datos en las tablas
  * @param dato WebservicesParse de la tabla
  */
  public recogerWSTabla(dato: WebservicesParse){

    this.numeroFilas = FILE_TABLE_DEF;
    this.numFilasDefecto();
    let ws = new Wsdefs();
    for(let i = 0; i < this.webservicesService.wsdefs.length; i++){
      if(this.webservicesService.wsdefs[i].code == dato.code){
           ws = _.cloneDeep(this.webservicesService.wsdefs[i]);
      }
    }

    this.loadingWSEnabled = true;
    this.webservicesService.recogerWSObservable(ws).subscribe(res => {
        console.log(res);
        this.error = false;
        this.loadingWSEnabled = false;
    }, error => {
        this.error = true;
        this.loadingWSEnabled = false;
        this.errorCargaWS('WARNINGS.error_ws');
        console.log("Error: " + error);
    });

  }

  /**
  * @description
  * función creada para adaptar la funcion recogerWS con el codigo del ws
  * @param dato CODIGO
  * @param posicionA Posicion que ocupa el setvalue seleccionado
  * @param posicionB Posicion que ocupa el ws seleccionado
  */
  public recogerWSBuscador(code: string, posicionA: number, posicionB: number, actPosic: number, evento: any){
    let ws = new Wsdefs();
    for(let i = 0; i < this.webservicesService.wsdefsrol.length; i++){
      if(this.webservicesService.wsdefsrol[i].code === code){
        ws = _.cloneDeep(this.webservicesService.wsdefsrol[i]);
      }
    }
    this.recogerWS(ws, posicionA, posicionB, actPosic, evento);
  }

  /**
  * @description
  * Comprueba si el valor del dato coincide con su etiqueta y correspondiente tipado del mismo
  * @param item1 Posicion que ocupan los valores del WS
  * @param item2 Posicion que ocupa el formato del valor seleccionado
  * @param error Verdadero o Falso
  */
  public tipadoRegistros(item1: number, item2: number){
    if(item1 == item2){
      return true;
    }else{
      return false;
    }
  }

  /**
  * @description
  * Redirigimos al servidor para que nor ordene las columnas de las tablas de los ws
  * @param text code de la etiqueta para identificar la columna que hemos pulsado a ordenar
  * @param numero botón al que pulsamos (1 - orden ascendente; 2 - orden descendente)
  */
  public ordenarColumnas(text: any, numero: number, posicion: number){
    this.webservicesService.ordenarColumnas(text, numero, posicion);
  }
  
  /**
  * @description
  * Saca un Cuadro de dialogo al pulsar una fila de la tabla con los datos del WS
  * @param datos datos del ws seleccionado en la tabla
  */
  public dialogoValorWS(datos: Array<WebserviceValorDato>) {

    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";

    let wscode = this.webservicesService.webserviceVista.code;
    let cat = this.webservicesService.webserviceVista.cat;
    let esp = this.webservicesService.webserviceVista.esp;
    let etiquetas = this.webservicesService.webserviceVista.etiquetas;
    let wscodexml = this.webservicesService.webserviceVista.codXmldef;
    let entorno = ROOT_INTERNA;

    const dialogRef = this.dialog.open(DialogsDatoswsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      autoFocus: false,
      data: { datos, wscode, cat, esp, etiquetas, wscodexml, entorno }
    });
    dialogRef.afterClosed();
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar error que no hay listado a exportar
  */
  public exportarDatos(){
    let forzarerror = this.webservicesService.exportarDatos();
    if(forzarerror == 0){
      this.errorCargaWS("WARNINGS.error_data_export");
    }
  }

  /*public onCloseClick(){
    this.webservicesService.coment = false;
  }*/

  /**
  * @description
  * Según resolución de pantalla se insertará por defecto el numero de filas visibles en las tablas
  */
  public numFilasDefecto(){

    let resolucion = window.screen.width;
      
    if(resolucion < 500){
      this.numeroFilas = FILE_TABLE.MOVIL;
    } else if(resolucion > 500 && resolucion < 750) {
      this.numeroFilas = FILE_TABLE.TABLET;
    } else{
      this.numeroFilas = FILE_TABLE.PC;
    }
  }

  /**
  * @description
  * Según resolución de pantalla se elegirá un tipo de combo a la hora de confugurar las filas 
  * visibles en tablas
  */
  public numFilasCombo(){
    let resolucion = window.screen.width;
      
    if(resolucion < 500){
      this.numFilas = NUM_FILE_TABLE_OPTIONS.MOVIL;
    } else if(resolucion > 500 && resolucion < 750) {
      this.numFilas = NUM_FILE_TABLE_OPTIONS.TABLET;
    } else{
      this.numFilas = NUM_FILE_TABLE_OPTIONS.PC;
    }
  }

}
